import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import type { FrontendRule } from '@cadstrom/backend/shared';

export type AbilityOverrideAtomValue = {
	rules: FrontendRule[] | null;
};

/**
 * Atom which supports the "View as user" feature.
 * Persisted in session storage so it survives page refreshes but not browser restarts.
 */
export const abilityOverrideAtom = atomWithStorage<AbilityOverrideAtomValue>(
	'ability-override',
	{
		rules: null,
	},
	createJSONStorage(() => sessionStorage),
);
